import {Component, Input, OnInit} from '@angular/core';
import {LoaderService} from '../../../services/common/loader-service/loader.service';
import {BehaviorSubject} from 'rxjs';

@Component({
  selector: 'side-panel',
  templateUrl: './side-panel.component.html',
  styleUrls: ['./side-panel.component.scss']
})
export class SidePanelComponent implements OnInit {

  @Input() title: string = null;
  @Input() side: 'left'|'right' = null;

  panelClosed = false;
  constructor(private loaderService: LoaderService) { }
  isSidePanelLoading: BehaviorSubject<boolean> = this.loaderService.isSidePanelLoading;


  ngOnInit(): void {
  }

}
